<script setup>
import { ref } from 'vue';
defineProps({
    count: {
        type: Number,
        required: true,
    },
});

const remainderButton = ref(null);
defineExpose({
    remainderButton: remainderButton
});
</script>

<template>
    <button
        ref="remainderButton"
        type="button"
        class="filter-button filter-button--remainder-count"
        v-if="count > 0"
    >
        +&nbsp;{{ count }}
    </button>
</template>
